import { useReducer } from 'react';

/**
 * Usage:
 *  const [$render, forceRender] = useForceRender();
 *  // Calling forceRender() will re-render the component
 *  // $render will will be updated after each call to forceRender(). Useful for forcing-update of hooks / children
 *
 * @return {[Number, Function]}
 */
export const useForceRender = () => useReducer((s) => s + 1, 1);
